import {useState, useEffect} from "react"

import {Team, TeamState} from "@irati/types"
import authentication from "@irati/auth"
import {QueryOptions} from "@irati/utils/services/apollo"

import {useLazyTeamsPaginated} from "../../hooks"
import teamsService from "../../services/teams"

export function useLazyAllTeams(businessId: string = authentication.business().uuid, state?: TeamState, limit = 20) {
  const [teams, setTeams] = useState<Team[]>([])
  const [loading, setLoading] = useState(true)
  const [allTeams, apollo] = useLazyTeamsPaginated({businessId, limit, state})

  useEffect(() => {
    if (apollo.data && apollo.called) {
      setTeams([...teams, ...apollo.data?.teams])
      if (apollo.data?.searchAfter) {
        allTeams({variables: {businessId, limit, searchAfter: apollo.data?.searchAfter, state}})
      } else {
        setLoading(false)
      }
    }
  }, [apollo?.data])

  return [allTeams, {...apollo, data: {teams}, loading}] as const
}

export function getAllTeams(
  businessId: string = authentication.business().uuid,
  state?: TeamState,
  limit: number = 20,
  previousTeams: Team[] = [],
  searchAfter?: string,
  options?: QueryOptions,
  hasBranding?: boolean,
  hasManager?: boolean
): Promise<Team[]> {
  return teamsService.teamsPaginated(businessId, undefined, limit, searchAfter, state, options, hasBranding, hasManager).then((res) => {
    const teams = [...previousTeams, ...res?.teams]
    if (res?.searchAfter) {
      return getAllTeams(businessId, state, limit, teams, res?.searchAfter, options, hasBranding, hasManager)
    }
    return teams
  })
}

export default {
  useLazyAllTeams,
  getAllTeams
}
